"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const blockly_1 = require("@/views/program/components/Blockly/patch/blockly");
class ToolboxCategory extends blockly_1.Blockly.ToolboxCategory {
    constructor(categoryDef, parentToolbox, opt_parent) {
        super(categoryDef, parentToolbox, opt_parent);
    }
}
